import React, { useEffect } from "react";
import { observer } from "mobx-react";
import { BrowserRouter, Route, Switch } from "react-router-dom";

import { Intro, GlobalErrorPanel } from "..";
import { useStore } from "../../store";
import Feeds from "../../pages/Feeds";
import Search from "../../pages/Search";
import Detail from "../../pages/Detail";
import { GlobalErrorType } from "../../store/appStoreTypes";

const AppView = () => {
  const {
    appStore: { isInitLoading, appErrorState },
  } = useStore();

  useEffect(() => {
    // push #title 로 진입할 경우 kmwd-337
    if (window.location.hash) {
      const { origin, hash, pathname } = window.location;
      const encodeTag = encodeURIComponent(hash);
      window.location.href = origin + pathname + encodeTag;
    }
  }, []);

  if (isInitLoading) return <Intro />;
  if (appErrorState !== GlobalErrorType.NONE) return <GlobalErrorPanel />;

  return (
    <React.Fragment>
      <GlobalErrorPanel />
      <BrowserRouter>
        <Switch>
          <Route exact path={["/", "/feeds", "/feeds/:id"]} component={Feeds} />
          <Route exact path={["/search", "/search/:tag"]} component={Search} />
          <Route exact path={["/detail", "/detail/:id"]} component={Detail} />
        </Switch>
      </BrowserRouter>
    </React.Fragment>
  );
};

export default observer(AppView);
